import { app } from '../../app';

app.run(init);

/** @ngInject */
function init($rootScope) {
    $rootScope.pushLoginButtonPopoverTemplate = require('./push-login-button-popover.html');
}



// WEBPACK FOOTER //
// ./src/portal/partials/push-login-button-popover/push-login-button-popover.js